import { useState } from 'react'
import { RecordCombobox } from '@/components/ui/record-combobox'
import { useAccounts } from '@/hooks/use-api'
import { useDebounce } from '@/hooks/use-debounce'

/** Pick a GRM account, searching the server as you type. */
export function AccountSearchPicker({
  id,
  value,
  selectedLabel,
  onChange,
  ariaLabel,
  initialSearch = '',
}: {
  id: string
  value: string
  selectedLabel?: string
  onChange: (accountId: string, accountName: string) => void
  ariaLabel: string
  /** Pre-fills the search, e.g. with the QuickBooks customer name. */
  initialSearch?: string
}) {
  const [search, setSearch] = useState(initialSearch)
  const debounced = useDebounce(search, 300)
  const { data, isLoading } = useAccounts({ search: debounced, limit: 20, page: 1 })
  const records = (data?.data ?? []).map((a) => ({ id: a.id, name: a.name || a.id }))
  return (
    <RecordCombobox
      id={id}
      records={records}
      value={value}
      onValueChange={(v) => onChange(v, records.find((r) => r.id === v)?.name ?? '')}
      displayField={(r: { name: string }) => r.name}
      selectedLabel={selectedLabel}
      placeholder="Choose an account…"
      searchPlaceholder="Search accounts…"
      emptyMessage="No accounts found"
      aria-label={ariaLabel}
      onSearchChange={setSearch}
      isLoading={isLoading}
      totalCount={data?.total}
    />
  )
}
